import { render } from "./LetsTalkPage.vue?vue&type=template&id=a556c50c&scoped=true"
import script from "./LetsTalkPage.vue?vue&type=script&lang=js"
export * from "./LetsTalkPage.vue?vue&type=script&lang=js"

import "./LetsTalkPage.vue?vue&type=style&index=0&id=a556c50c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a556c50c"]])

export default __exports__